import moment from 'moment'
import React from 'react'
import PropTypes from 'prop-types'
import 'react-datepicker/dist/react-datepicker.css'
import track from '../../utils/mixpanel-event'

import CalendarInput from './calendar-input'
import Cart from './transaction-cart'
import RefundModal from '../refund-modal'
import ReceiptModal from '../../containers/history/text-receipt-modal'

import DatePicker from 'react-datepicker'
import ChangeDateCalendar from '../../containers/history/change-date-calendar'

import TransactionReport from '../../utils/transactionReportClass'
import html2canvas from 'html2canvas-render-offscreen'
import RefundAlert from './refund-alert'
class Transactions extends React.Component {
  constructor() {
    super()
    this.state = {
      displayBatchReport: false,
      summaryReport: {},
      isReceiptOpened: false,
      isRefundOpened: false
    }
    this.hideReceipt =this.hideReceipt.bind(this)
    track('Page View', {page: 'Transaction History'})
  }

  transactionToCart(transaction) {
    return { id: transaction ? transaction.receipt.id : null, items: transaction ? transaction.items : [] }
  }

  calendar() {
    return (
      <DatePicker
        customInput={<CalendarInput />}
        selected={this.props.selectedDate}
        onChange={this.props.onChangeDate}
        value={
          this.props.selectedDate.isSame(moment(), 'day')
            ? 'Today'
            : this.props.selectedDate.format('MM/DD/YYYY')
        }
      />
    )
  }

  searchForm() {
    return (
      <form onSubmit={this.props.onSubmitSearch}>
        <input
          type='text'
          name='query'
          value={this.props.searchString}
          className='transactions-history__search-input'
          onChange={this.props.onChangeSearch}
          placeholder='Search last 4 of CC, or by receipt #'
        />
        <input
          type='submit'
          value='Search'
          className='transactions-history__search-submit'
        />
      </form>
    )
  }

  mainBlockRender() {
    const transactions = this.props.transactions
    const ids = this.props.sortedTransactionIds
    return (
      <div className='transactions-block'>
        <div className='transactions-block__header'>Recent Transactions</div>
        <div className='transactions-block__date-picker'>{this.calendar()}</div>
        <div className='transactions-block__scroll-wrap'>
          <div className='transactions-block__content'>
            {ids.map((id) => {
              const tr = transactions[id]
              return (
                <div
                  key={id}
                  className='transactions-block_item'
                  onClick={this.props.onClickTransaction.bind(null, id, tr.status == 'refunded')}
                >
                  <span className='transactions-block_item__time'>
                    {moment(tr.time).format('h:mm A')}
                  </span>
                  <span className='transactions-block_item__info'>
                    <p className='transactions-block_item__type'>
                      {`${tr.source} Sale`}
                      {tr.touchless && <span className='touchless'><img src='/shop/touchless.png' /></span>}
                    </p>
                    <p className='transactions-block_item__id'>
                      {tr.number || tr.id}
                      <span className='transactions-block_item__status'>
                        {tr.status == 'refunded' ?
                          tr.paymentStatus.charAt(0).toUpperCase() + tr.paymentStatus.slice(1) :
                          ''}
                      </span>
                    </p>
                  </span>
                  <span className='transactions-block_item__amount'>
                    {tr.totalAmountWithoutTip}
                  </span>
                </div>
              )
            })}
          </div>
        </div>
        <div className='transactions-history__buttons'>
          {this.props.refundDisabled ? (
            <span />
            ) : (
            <button
              className='transactions-history_button'
              onClick={() => this.setState({ isRefundOpened: true })}
            >
              Return
            </button>
          )}
          <button
            className='transactions-history_button'
            onClick={(e) => this.toggleTextReceipt()}
            >
            {window.App.config.printerAllowed
              ? 'Print Receipt'
              : 'Text Receipt'}
          </button>
        </div>
      </div>
    )
  }
  
  toggleTextReceipt() {
    this.setState({ isReceiptOpened: !!this.props.transactions[this.props.currentTransactionId] })
    this.props.onClickReceipt()
  }

  hideReceipt() {
    this.setState({ isReceiptOpened: false })
  }

  makeTransactionReport() {
    const transactions = this.props.transactions
    const refundedTransactions = Object.keys(transactions)
      .filter(key => key != 'allIds')
      .reduce((cur, key) => {
        return transactions[key].status == 'refunded' ? Object.assign(cur, { [key]: transactions[key] }) : cur
      }, {})

    let countableTransactions = Object.keys(transactions)
      .filter(key => key != 'allIds')
      .reduce((cur, key) => {
        return transactions[key].status != 'refunded' ? Object.assign(cur, { [key]: transactions[key] }) : cur
      }, {})

    let txObject = {
      transactions: Object.values(countableTransactions),
      refundedTransactions: Object.values(refundedTransactions)
    }

    let txCollection = new TransactionReport(txObject)
    return txCollection
  }

  screenshotAndPrintBatchReceipt() {
    const batchReportElem = document.querySelector('#batch-total-receipt')
    const reportButtonsElem = document.querySelector(
      '.transactions-history__buttons'
    )
    const batchReportContent = batchReportElem.querySelector(
      '.transactions-block__scroll-wrap'
    )
    const heightInitial = batchReportContent.style.height
    const overflowInitial = batchReportContent.style.overflow

    batchReportContent.style.overflow = 'visible'
    batchReportContent.style.height = 'auto'
    reportButtonsElem.style.visibility = 'hidden'

    batchReportContent.scrollIntoView(false)

    const printWindow = window.open('', 'PrintWindow', 'width=900,height=600')
    html2canvas(batchReportElem).then(function(canvas) {
      const doc = printWindow.document
      const img = doc.createElement('img')
      img.src = canvas.toDataURL('image/png')
      doc.body.appendChild(img)
      setTimeout(() => {
        printWindow.print()
        printWindow.close()
        batchReportContent.style.overflow = overflowInitial
        batchReportContent.style.height = heightInitial
      }, 0)
    })

    reportButtonsElem.style.visibility = 'visible'
  }

  batchReportRender() {
    const {
      allNetAmount,
      allCashAmount,
      allZelleAmount,
      allCheckAmount,
      allTipAmount,
      reservationCardAmount,
      reservationNetAmount,
      shopCardAmount,
      shopNetAmount
    } = this.props.summaryReport
    this.batchReport = this.makeTransactionReport()

    return (
      <div id='batch-total-receipt' className='transactions-block'>
        <div className='transactions-block__header'>
          Batch Report for {this.props.selectedDate.format('MMMM D YYYY')}
        </div>
        <div className='transactions-block__date-picker'>{this.calendar()}</div>
        <div className='transactions-block__scroll-wrap'>
          <div className='transactions-block__content'>
            {/*Summary*/}
            <div key='summary' className='transactions-block_item'>
              <span className='transactions-block_item__info'>
                <p className='transactions-block_item__type'>Field Rentals</p>
              </span>
              <span className='transactions-block_item__amount'>
                $ {reservationNetAmount ? reservationNetAmount.toFixed(2) : '0.00'}
              </span>
            </div>

            <div key='academySalesTotalPOS' className='transactions-block_item'>
              <span className='transactions-block_item__info'>
                <p className='transactions-block_item__type'>POS Sales</p>
              </span>
              <span className='transactions-block_item__amount'>
                {/* Subtract Academy sales from POS because Academy is technically POS too */}
                ${' '}
                {(shopNetAmount - this.batchReport.academySalesTotal).toFixed(
                  2
                )}
              </span>
            </div>

            {/* If no Academy sales, do not display */}
            {/* Hacky way to hide for every company without Academy group (IE not Soccer5) */}
            {/* Will not display for Soccer5 until Academy sales for the day */}
            {this.batchReport.academySales != 0 && (
              <div key='academySalesTotal' className='transactions-block_item'>
                <span className='transactions-block_item__info'>
                  <p className='transactions-block_item__type'>Academy</p>
                </span>
                <span className='transactions-block_item__amount'>
                  $ {this.batchReport.academySalesTotal.toFixed(2)}
                </span>
              </div>
            )}

            <div key='tips' className='transactions-block_item'>
              <span className='transactions-block_item__info'>
                <p className='transactions-block_item__type'>Tips</p>
              </span>
              <span className='transactions-block_item__amount'>
                $ {allTipAmount.toFixed(2)}
              </span>
            </div>

            <div key='totalSales' className='transactions-block_item'>
              <span className='transactions-block_item__info'>
                <p className='transactions-block_item__type'>Total Sales</p>
              </span>
              <span className='transactions-block_item__amount'>
                $ {allNetAmount.toFixed(2)}
              </span>
            </div>

            {/*Sales Breakdown*/}
            <div className='transactions-block__header'>Sales Breakdown</div>

            <div key='creditCard' className='transactions-block_item'>
              <span className='transactions-block_item__info'>
                <p className='transactions-block_item__type'>Credit Card</p>
              </span>
              <span className='transactions-block_item__amount'>
                $ {(reservationCardAmount + shopCardAmount).toFixed(2)}
              </span>
            </div>

            <div key='cash' className='transactions-block_item'>
              <span className='transactions-block_item__info'>
                <p className='transactions-block_item__type'>Cash</p>
              </span>
              <span className='transactions-block_item__amount'>
                $ {allCashAmount.toFixed(2)}
              </span>
            </div>

            { allZelleAmount &&
              <div key='zelle' className='transactions-block_item'>
                <span className='transactions-block_item__info'>
                  <p className='transactions-block_item__type'>Zelle</p>
                </span>
                <span className='transactions-block_item__amount'>
                  $ {allZelleAmount.toFixed(2)}
                </span>
              </div>
            }

            { allCheckAmount &&
                <div key='cash' className='transactions-block_item'>
                <span className='transactions-block_item__info'>
                  <p className='transactions-block_item__type'>Check</p>
                </span>
                  <span className='transactions-block_item__amount'>
                  $ {allCheckAmount.toFixed(2)}
                </span>
                </div>
            }

            <div key='tipsBreakdown' className='transactions-block_item'>
              <span className='transactions-block_item__info'>
                <p className='transactions-block_item__type'>Tips</p>
              </span>
              <span className='transactions-block_item__amount'>
                $ {allTipAmount.toFixed(2)}
              </span>
            </div>

            <div key='refunds' className='transactions-block_item'>
              <span className='transactions-block_item__info'>
                <p className='transactions-block_item__type'>Refunds</p>
              </span>
              <span className='transactions-block_item__amount'>
                $ {this.batchReport.refundTotal.toFixed(2)}
              </span>
            </div>

            <div key='tax' className='transactions-block_item'>
              <span className='transactions-block_item__info'>
                <p className='transactions-block_item__type'>Tax</p>
              </span>
              <span className='transactions-block_item__amount'>
                $ {this.batchReport.taxTotal.toFixed(2)}
              </span>
            </div>

            {/*Card Types*/}
            <div className='transactions-block__header'>Card Types</div>

            {this.batchReport.cardBreakdown.map((cardEntry) => (
              <div key='cartType' className='transactions-block_item'>
                <span className='transactions-block_item__info'>
                  <p className='transactions-block_item__type'>
                    {cardEntry.cardType}
                  </p>
                </span>
                <span className='transactions-block_item__amount'>
                  $ {cardEntry.total.toFixed(2)}
                </span>
              </div>
            ))}
          </div>
        </div>
        <div className='transactions-history__buttons'>
          {this.props.refundDisabled ? (
            <span />
            ) : (
            <button
              className='transactions-history_button'
              onClick={() => this.setState({ isRefundOpened: true })}
            >
              Return
            </button>
          )}
          <button
            className='transactions-history_button'
            onClick={() => this.screenshotAndPrintBatchReceipt()}
          >
            Print Batch Totals
          </button>
        </div>
      </div>
    )
  }

  toggleBatchReport() {
    this.setState({ displayBatchReport: !this.state.displayBatchReport })
  }

  refundPayment() {
    this.props.onRefundPayment()
    this.setState({ isRefundOpened: false })
  }

  refundReceipt() {
    this.props.onRefundReceipt()
    this.setState({ isRefundOpened: false })
  }

  render() {
    const transaction = this.props.transactions[this.props.currentTransactionId]
    const cartData = this.transactionToCart(transaction)
    const discountData = {
      amount: transaction ? transaction.amountDiscount : 0,
      percentage: transaction ? transaction.percentageDiscount : 0
    }

    const discountAmount = transaction ? transaction.amountDiscount : 0
    const discountPercentage = transaction ? transaction.percentageDiscount : 0
    let net = 0
    let tax = 0
    let cartPrice
    let percentDiscount = 1

    if (transaction) {
      transaction.items.map((item) => {
        net += item.netAmount
        tax += item.netAmount * item.taxRate
      })
      cartPrice = net + tax

      if (discountPercentage > 0) {
        percentDiscount = (100 - discountPercentage) / 100
      } else if (discountAmount > 0) {
        percentDiscount = (cartPrice - discountAmount) / cartPrice
      }
    }

    return (
      <div className='transactions-history'>
        <div className='transactions-history__cart'>
          <Cart
            transaction={cartData}
            discount={discountData}
            percentDiscount={percentDiscount}
            currency={window.App.shop.currency}
            displayBatchReport={this.state.displayBatchReport}
            batchReportDisabled={Object.keys(this.props.summaryReport).length == 0}
            toggleBatchReport={() => this.toggleBatchReport()}
          />
          <ChangeDateCalendar />
        </div>
        <div className='transactions-history__search-field'>
          {this.searchForm()}
        </div>
        <div className='transactions-history__list'>
          {this.state.displayBatchReport
            ? this.batchReportRender()
            : this.mainBlockRender()}
          {this.props.alert && <RefundAlert
            title={this.props.alert.title}
            text={this.props.alert.text}
            type={this.props.alert.type}
            onHide={this.props.onCleanAlert}
          />}
        </div>
        { this.state.isRefundOpened && 
          <RefundModal
            transaction={this.props.transactions[this.props.currentTransactionId]}
            onClose={() => this.setState({ isRefundOpened: false })}
            onConfirm={() => this.refundPayment()}
            onConfirmReceipt={() => this.refundReceipt()}
          />
        }
        {!window.webkit && <ReceiptModal
              isOpen={this.state.isReceiptOpened}
              hideReceipt={this.hideReceipt}
              transactions={this.props.transactions}
          />
        }
      </div>
    )
  }
}

Transactions.propTypes = {
  currentTransactionId: PropTypes.number,
  searchString: PropTypes.string.isRequired,
  selectedDate: PropTypes.object.isRequired,
  sortedTransactionIds: PropTypes.array.isRequired,
  transactions: PropTypes.object.isRequired,
  refundDisabled: PropTypes.bool,
  summaryReport: PropTypes.object,
  alert: PropTypes.object,
  onChangeDate: PropTypes.func,
  onChangeSearch: PropTypes.func,
  onClickTransaction: PropTypes.func,
  onSubmitSearch: PropTypes.func,
  onCleanAlert: PropTypes.func
}

export default Transactions
